import { restLog } from "src/utils/functions/logging"
import { content, isJson, msg, _logout, isLocal, noti } from "src/utils/functions/core"
// import { checkNode } from "./queryCheck"
// console.log(layout)
const headers = (method) => {
  const { user, layout, token, licence } = content()
  // console.log(licencedevMode)
  const devMode = licence?.devMode
  const browserId = isLocal("browserId")
  return {
    'Content-Type': 'application/json',
    'token': token,
    'userId': user?._id,
    'devMode': licence?.devMode,
    'userGroupId': user?.references?.userGroupId?.$ref,
    'browserId': browserId,
    'pathname': window.location.pathname,
    'method': method
  }
}

const API_PREFIX = "/api/";

// Ensures URL always starts with /api/
const normalizeUrl = (url) => {
  if (!url) return url;
  return url.startsWith("/api/") ? url : API_PREFIX + url;
};

const getFetch = (url, obj) => {
  if (!url) {
    msg("error", "Missing URL", 2);
  }
  if (!obj) {
    msg("error", "Missing data", 2);
  }

  try {
    const finalUrl = normalizeUrl(url);
    const s = obj?.param ? ("?" + obj?.param + "=") : "?body=";

    return fetch(finalUrl + s + JSON.stringify(obj), {
      method: "GET",
      headers: headers("GET"),
    })
      .then((response) => response.json())
      .then((data) => {
        data?.msg && msg(...data.msg);
        data?.noti && noti(...data.noti);
        delete data.msg;
        delete data.noti;
        return data;
      })
      .catch((error) => console.log(error));
  } catch (e) {
    console.log(e);
  }
};

const putFetch = (url, obj) => {
  const finalUrl = normalizeUrl(url);

  return fetch(finalUrl, {
    method: "PUT",
    headers: headers("PUT"),
    body: JSON.stringify(obj),
  })
    .then((response) => response.json())
    .then((data) => {
      data?.msg && msg(...data.msg);
      data?.noti && noti(...data.noti);
      delete data.msg;
      delete data.noti;
      return data;
    })
    .catch((error) => console.log(error));
};

const postFetch = (url, obj) => {
  const finalUrl = normalizeUrl(url);

  return fetch(finalUrl, {
    method: "POST",
    headers: headers("POST"),
    body: JSON.stringify(obj),
  })
    .then((response) => response.json())
    .then((data) => {
      data?.msg && msg(...data.msg);
      data?.noti && noti(...data.noti);
      delete data.msg;
      delete data.noti;
      return data;
    })
    .catch((error) => console.log(error));
};

const dbExist = (db) => {
  const defaultKeys = ["bucket", "dbName", "databaseName"]
  const keys = Object.keys(db)
  for (var i = 0; i < keys.length; i++) {
    const ifExist = defaultKeys.find((f) => f === keys[i])
    if (ifExist) {
      return ifExist
    }
  }
}

const dbConfig = (e) => {
  const type = e?.db?.type
  // console.log(e)
  if (type === "couchbase") {
    return{
      db: e?.db?.[dbExist(e?.db)],
      get: e?.fetch?.get,
      type: e?.fetch?.type,
    }
  }else if (type === "mongoDB") {
    return{
      ...e?.db,
      db: e?.db?.[dbExist(e?.db)],
      get: e?.fetch?.get,
      type: e?.fetch?.type,
    }
  }else if (type === "mySql") {

  }else {
    return{
      db: false,
      get: e?.fetch?.get,
      type: e?.fetch?.type,
    }
  }
}

const contentCache = async(b) => {
  const { user } = content()
  const _userId = user?._id
  const f = await getFetch("getBeCache", { key: _userId })
  if (f?.success) {
    return f?.[_userId + "-localStorage"]
  }else {
    return null
  }
}

const updateContentCache = async(body) => {
  const { user } = content()
  const _userId = user?._id
  const f = await postFetch("updateContentCache", { key: _userId, body })
}

const destroyContentCache = async() => {}

export {
  contentCache,
  updateContentCache,
  destroyContentCache,
  getFetch,
  putFetch,
  postFetch,
  dbConfig
}
